module.exports = __webpack_public_path__ + "img/s05.0548d0a6.png";